import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';
import { typeFormatter, paymentTypeFormatter } from '../../components/formatters/defFormatter';
import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { clientOrderColumnDefs } from '../../components/tables/columnDefs';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';


import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';






function AllTransaction(props) {

  let { type } = props;


  const { userData,  api, refClass, classData } = useContext(DataContext);
  const userRole = userData.role;
  
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);




  const table = 'transaction';
  const title = 'All Transaction';



  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [filter, setFilter] = useState({ search: '', isActive: 'true', fromDate: today, toDate: today });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
 


  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }

  //Excel Data
  const getExcelData =  (data) => {

    const transformedData = [];
    data.forEach(item => {
      
      const newItem = {
        id: item.id,
        account: item.account?.name,
      };
  
      transformedData.push(newItem);
    });
  
    return transformedData;
  };

  let columnDefs = [
    { title: 'createdAt', dataIndex: 'createdAt', render: dateTableFormatter },
    { title: 'Barcode', dataIndex: 'member', render: (account) => (account?.barcode) },
    { title: 'member', dataIndex: 'member', render: (account) => (account?.name) },
    { title: 'trainer', dataIndex: 'trainer', render: (trainer) => (trainer?.name) },
    { title: 'type', dataIndex: 'type', render: typeFormatter },
    { title: 'usd', dataIndex: 'usd', width: '8%' },

  ];



    
    
      return (
        <div className='card'>
    
          {isLoading &&
            <Loader />
          }
    
    
          {!isLoading &&
            <>
              <div>
    
                <SearchFilter setFilter={setFilter} />
                <DatePicker setFilter={setFilter} filter={filter} />
                
    
              </div>
    
    
    
              <SimpleTable
                filter={filter}
                table={table}
                title={title}
                columnDefs={columnDefs}
                idRow={idRow}
                setIdRow={setIdRow}
                refreshTable={refreshTable}
                data={data}
                setData={setData}
                api={api}
                getExcelData={getExcelData}
              />
    
          
    
            </>
          }
    
        </div>
      )
    }
    
export default AllTransaction;
